import { render, staticRenderFns } from "./VCheckBox.vue?vue&type=template&id=540d92cc&scoped=true&"
import script from "./VCheckBox.vue?vue&type=script&lang=js&"
export * from "./VCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./VCheckBox.vue?vue&type=style&index=0&id=540d92cc&lang=scss&scoped=true&"
import style1 from "./VCheckBox.vue?vue&type=style&index=1&id=540d92cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540d92cc",
  null
  
)

export default component.exports